import { Injectable } from '@angular/core';
import { loaderInProgressSelector } from '@macs-frontend/reducers';
import { Store } from '@ngrx/store';
import * as mobx from 'mobx-angular';
import { Observable } from 'rxjs';
import { makeObservable } from '../utils/mobx';
import { BaseStore } from './base.store';

@Injectable({
  providedIn: 'root',
})
export class LoaderStore extends BaseStore {
  @mobx.observable
  loaders: readonly string[] = [];

  loaderInProgress$: Observable<readonly string[]>;

  constructor(store$: Store<any>) {
    super();

    makeObservable(this);

    this.loaderInProgress$ = store$
      .select(loaderInProgressSelector)
      .pipe(this.takeUntilDestroy());

    this.loaderInProgress$.subscribe(
      mobx.action((loaders: readonly string[]) => {
        this.loaders = loaders;
      }),
    );
  }
}
